import { algoliasearch } from "algoliasearch";
import { getCountry, getLang } from "../../router/scripts/params";
import { getAppEnv } from "../../common/scripts/config/app";

const client = algoliasearch("TM8JOGS2X7", "ca3586879df62e842310a907e8e36b18");

// Search in Algolia
export async function search(q: string, hitsPerPage = 500): Promise<any> {
  return await client.searchSingleIndex({
    indexName: `${getAppEnv()}_product_${getLang()}`,
    searchParams: {
      query: q,
      facetFilters: [`countryCodes:${getCountry()}`],
      hitsPerPage,
    },
  });
}
